import { persist } from 'zustand/middleware';

import { initialSorting } from '@constants/tableSorting';

import { createStore } from '@store/createStore';

const useAssetHealthOverviewStorePersist = createStore(
  persist(
    (set) => ({
      urgency: { value: 'all', label: 'All' },
      causeCategoryTableSorting: { ...initialSorting },
      equipmentTableSorting: { ...initialSorting },

      actions: {
        setAssetHealthUrgency: (urgency) => set({ urgency }),
        setAssetHealthCauseCategorySorting: (causeCategoryTableSorting) => set({ causeCategoryTableSorting }),
        setAssetHealthEquipmentSorting: (equipmentTableSorting) => set({ equipmentTableSorting }),
        setAssetHealthResetSorting: () =>
          set({
            causeCategoryTableSorting: { ...initialSorting },
            equipmentTableSorting: { ...initialSorting },
          }),
      },
    }),
    {
      version: 1,
      name: 'asset-health-filter',
      partialize: (state) =>
        Object.fromEntries(
          Object.entries(state).filter(
            ([key]) =>
              key !== 'actions' && key !== 'equipmentTableSorting' && key !== 'causeCategoryTableSorting',
          ),
        ),
    },
  ),
  'AssetHealthOverviewStorePersist',
);

export const useAssetHealthOverviewStoreActions = () =>
  useAssetHealthOverviewStorePersist((state) => state.actions);

export const selectAssetHealthUrgency = () => useAssetHealthOverviewStorePersist((state) => state.urgency);
export const selectAssetHealthCauseCategorySorting = () =>
  useAssetHealthOverviewStorePersist((state) => state.causeCategoryTableSorting);
export const selectAssetHealthEquipmentSorting = () =>
  useAssetHealthOverviewStorePersist((state) => state.equipmentTableSorting);
